import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

const KEY = "etprime_cookie_consent_v1";

const applyConsent = (accepted) => {
  try {
    if (window.posthog) {
      if (accepted) window.posthog.opt_in_capturing();
      else window.posthog.opt_out_capturing();
    }
  } catch {}
};

export const CookieConsent = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    let choice = null;
    try {
      choice = localStorage.getItem(KEY);
    } catch {}
    if (!choice) setShow(true);
    else applyConsent(choice === "accepted");
  }, []);

  const decide = (accepted) => {
    try {
      localStorage.setItem(KEY, accepted ? "accepted" : "declined");
    } catch {}
    applyConsent(accepted);
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      className="fixed bottom-4 left-4 right-4 md:left-6 md:right-auto md:max-w-md z-[70] bg-[#11151C] border border-white/10 shadow-2xl"
      data-testid="cookie-consent"
    >
      <div className="p-6">
        <div className="flex items-center gap-3">
          <Cookie className="text-[#C8A45A]" size={18} />
          <span className="overline">Analytics & cookies</span>
        </div>
        <p className="text-sm text-[#A1A5AB] mt-4 leading-relaxed">
          We use strictly necessary cookies to operate this site and analytics cookies (including PostHog) to
          understand usage, as described in our{" "}
          <Link to="/legal/privacy" className="text-[#C8A45A] underline" data-testid="cookie-privacy-link">
            Privacy Policy
          </Link>
          . You can accept or decline analytics cookies.
        </p>
        <div className="flex gap-3 mt-6">
          <button
            onClick={() => decide(true)}
            data-testid="cookie-accept"
            className="flex-1 bg-[#C8A45A] text-[#0A0D12] hover:bg-[#D4B572] transition-colors px-5 py-3 text-sm font-medium tracking-wide"
          >
            Accept analytics
          </button>
          <button
            onClick={() => decide(false)}
            data-testid="cookie-decline"
            className="flex-1 border border-white/20 text-[#A1A5AB] hover:text-white hover:border-white/40 transition-colors px-5 py-3 text-sm tracking-wide"
          >
            Decline
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
